<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-flex xs12 sm6 md1>
            <router-link to="/Dashboard">
              <v-btn icon dark >
                <v-icon>keyboard_backspace</v-icon>
              </v-btn>
            </router-link>
          </v-flex>  
          <v-flex xs12 sm6 md1>
            <h2>
              GSTR-1
            </h2>
          </v-flex>
          <v-flex xs12 sm6 md1>
          </v-flex>  
          <v-flex xs12 sm6 md4>
            <v-select
              class="select-firm"
              dense 
              flat
              clearable
              item-text="name"
              return-object
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-select
              class="select-firm"
              dense 
              flat
              :items="['Monthly','Quarterly','Custom']"
              label="Filter type"
              v-model="filterType"
            ></v-select>
          </v-flex>
            <v-flex xs12 sm3 md4 v-if="filterType == 'Quarterly'">
               <v-select
                class="select-firm"
                dense 
                flat
                :items="quarters"
                label="Select Quarter"
                v-model="selectedQuarter"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm3 md4 v-if="filterType == 'Monthly'">
               <v-select
                class="select-firm"
                dense 
                flat
                :items="months"
                label="Select Month"
                v-model="selectedMonth"
              ></v-select>
            </v-flex>
          
          <v-flex xs12 sm3 md2 v-if="filterType == 'Custom'">
            <v-menu
              :close-on-content-click="false"
              v-model="datepickerFrom"
              :nudge-right="40"
              class="ist-datepicker"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="fromDate" @input="datepickerFrom = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm3 md2 v-if="filterType == 'Custom'">
            <v-menu
              :close-on-content-click="false"
              v-model="datepickerTo"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              class="ist-datepicker"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="toDate" @input="datepickerTo = false"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-toolbar>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm3 md3>
                  <template  v-if="selectedFirm">
                    <v-icon color = "primary"> perm_identity </v-icon>
                    <b>{{selectedFirm.name}}</b> -
                    <b>{{selectedFirm.GST_number}}</b>
                    <br/>
                    <v-icon color = "primary"> location_city </v-icon>
                    <b>{{generateAddress(selectedFirm)}}</b>
                    <br />
                    <v-icon color = "primary"> phone </v-icon>
                    <b>{{selectedFirm.mobileNumber}}</b>
                    <br />
                    <v-icon color = "primary"> email </v-icon>
                    <b>{{selectedFirm.email}}</b>
                  </template>
                </v-flex>
                
                <v-flex xs12 sm8 md8 style="overflow-x: auto;">
                <table class="fl-table">
                  <thead>
                    <tr>
                      <th>Expand</th>
                      <th>Description</th>
                      <th>Total Taxable Value</th>
                      <th colspan="4">TAX/GST Amounts</th>
                      <th>Total Invoices</th>
                    </tr>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th>IGST A.</th>
                      <th>CGST A.</th>
                      <th>SGST A.</th>
                      <th>CESS</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <v-icon
                          v-if="!outwardSupplies.expand"
                          @click="toggle(outwardSupplies)"
                          color="primary"
                        >expand_more</v-icon>
                        <v-icon
                          v-if="outwardSupplies.expand"
                          @click="toggle(outwardSupplies)"
                          color="primary"
                        >expand_less</v-icon>
                      </td>
                      <td>
                        <h2>OUTWARD SUPPLIES</h2>
                      </td>
                      <td>{{outwardSupplies.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                    <tr v-if="outwardSupplies.expand">
                      <td></td>
                      <td>
                        <h2 class="primary--text">
                          <b>(A). Intra state</b>
                        </h2>
                      </td>
                      <td>{{outwardSupplies.intraState.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                    <tr v-if="outwardSupplies.expand">
                        <td>
                        <v-icon
                          v-if="!outwardSupplies.intraState.taxable.expand"
                          @click="toggle(outwardSupplies.intraState.taxable)"
                          color="primary"
                        >expand_more</v-icon>
                        <v-icon
                          v-if="outwardSupplies.intraState.taxable.expand"
                          @click="toggle(outwardSupplies.intraState.taxable)"
                          color="primary"
                        >expand_less</v-icon>
                      </td>
                      <td>
                        <h4>(i). Taxable</h4>
                      </td>
                      <td>{{outwardSupplies.intraState.taxable.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <template v-if="outwardSupplies.intraState.taxable.expand">
                    <tr>
                      <td></td>
                      <td>
                        <h4>GST (3%)</h4>
                      </td>
                      <td>{{outwardSupplies.intraState.taxable.GST_3.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_3.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_3.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_3.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_3.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_3.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (5%)</h4>
                      </td>
                      <td>{{outwardSupplies.intraState.taxable.GST_5.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_5.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_5.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_5.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_5.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (12%)</h4>
                      </td>
                      <td>{{outwardSupplies.intraState.taxable.GST_12.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_12.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_12.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_12.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_12.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (18%)</h4>
                      </td>
                      <td>{{outwardSupplies.intraState.taxable.GST_18.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_18.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_18.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_18.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_18.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (28%)</h4>
                      </td>
                      <td>{{outwardSupplies.intraState.taxable.GST_28.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_28.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_28.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_28.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_28.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                    </template>
                    <tr v-if="outwardSupplies.expand">
                      <td></td>
                      <td>
                        <h4>(ii). Exempted</h4>
                      </td>
                      <td>{{outwardSupplies.intraState.exempted.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.exempted.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.exempted.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.exempted.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.exempted.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.exempted.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                    <tr v-if="outwardSupplies.expand">
                      <td></td>
                      <td>
                        <h4>(iii). Nill Rated</h4>
                      </td>
                      <td>{{outwardSupplies.intraState.nillrated.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.nillrated.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.nillrated.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.nillrated.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.nillrated.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.nillrated.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                    <tr v-if="outwardSupplies.expand">
                      <td></td>
                      <td>
                        <h4>(iv). Others</h4>
                      </td>
                      <td>{{outwardSupplies.intraState.others.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.others.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.others.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.others.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.others.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.others.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                    <tr v-if="outwardSupplies.expand">
                      <td></td>
                      <td>
                        <h2 class="primary--text">
                          <b>(B). Inter state</b>
                        </h2>
                      </td>
                      <td>{{outwardSupplies.interState.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                    <tr v-if="outwardSupplies.expand">
                       <td>
                        <v-icon
                          v-if="!outwardSupplies.interState.taxable.expand"
                          @click="toggle(outwardSupplies.interState.taxable)"
                          color="primary"
                        >expand_more</v-icon>
                        <v-icon
                          v-if="outwardSupplies.interState.taxable.expand"
                          @click="toggle(outwardSupplies.interState.taxable)"
                          color="primary"
                        >expand_less</v-icon>
                      </td>
                      <td>
                        <h4>(i). Taxable</h4>
                      </td>
                      <td>{{outwardSupplies.interState.taxable.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                    <template v-if="outwardSupplies.interState.taxable.expand">
                    <tr>
                      <td></td>
                      <td>
                        <h4>GST (3%)</h4>
                      </td>
                      <td>{{outwardSupplies.interState.taxable.GST_3.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_3.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_3.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_3.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_3.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_3.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (5%)</h4>
                      </td>
                      <td>{{outwardSupplies.interState.taxable.GST_5.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_5.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_5.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_5.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_5.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_5.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (12%)</h4>
                      </td>
                      <td>{{outwardSupplies.interState.taxable.GST_12.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_12.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_12.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_12.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_12.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_12.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (18%)</h4>
                      </td>
                      <td>{{outwardSupplies.interState.taxable.GST_18.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_18.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_18.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_18.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_18.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_18.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (28%)</h4>
                      </td>
                      <td>{{outwardSupplies.interState.taxable.GST_28.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_28.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_28.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_28.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_28.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_28.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                    </template>
                    <tr v-if="outwardSupplies.expand">
                      <td></td>
                      <td>
                        <h4>(ii). Exempted</h4>
                      </td>
                      <td>{{outwardSupplies.interState.exempted.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.exempted.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.exempted.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.exempted.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.exempted.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.exempted.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                    <tr v-if="outwardSupplies.expand">
                      <td></td>
                      <td>
                        <h4>(iii). Nill Rated</h4>
                      </td>
                      <td>{{outwardSupplies.interState.nillrated.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.nillrated.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.nillrated.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.nillrated.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.nillrated.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.nillrated.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                    <tr v-if="outwardSupplies.expand">
                      <td></td>
                      <td>
                        <h4>(iv). Others</h4>
                      </td>
                      <td>{{outwardSupplies.interState.others.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.others.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.others.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.others.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.others.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.others.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                  </tbody>
                </table>
            </v-flex>

            <v-flex xs12 sm1 md1>
              <v-btn round class="primary white--text" flat type="button" @click="exportAll()">
                Excel
                <v-icon dark> save_alt </v-icon>
              </v-btn>
              <br/>
              <v-btn round class="primary white--text" flat type="button" @click="printGST1()">
                Print
                <v-icon dark> print </v-icon>
              </v-btn>
               <br/>
              <v-btn round class="primary white--text" flat type="button" @click="downloadJSON()">
                JSON
                <v-icon dark> save_alt </v-icon>
              </v-btn>
              <a id="downloadAnchorElem" style="display:none"></a>
            </v-flex>

            </v-layout>
          </v-card-text>
        </v-card>
      <v-layout row wrap>
          <v-flex xs12 style="overflow-x: auto;">
            <table class="fl-table">
              <thead>
                <tr>
                  <th>S. No</th>
                  <th>Description of Invoices</th>
                  <th>Voucher Count</th>
                  <th>Total Taxable Value</th>
                  <th colspan="4">TAX/GST Amounts</th>
                  <th>Total Invoices</th>
                  <th>View</th>
                </tr>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th>IGST A.</th>
                  <th>CGST A.</th>
                  <th>SGST A.</th>
                  <th>CESS</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>
                    <h2>{{gst1_desc.B2B_invoices.title}}</h2>
                    {{gst1_desc.B2B_invoices.description}}
                  </td>
                  <td>{{gst1_desc.B2B_invoices.voucherCount}}</td>
                  <td>{{gst1_desc.B2B_invoices.totalBaseAmount || 0  | amount}}</td>
                  <td>{{gst1_desc.B2B_invoices.ICGST || 0 | amount}}</td>
                  <td>{{gst1_desc.B2B_invoices.CGST || 0 | amount}}</td>
                  <td>{{gst1_desc.B2B_invoices.SGST || 0 | amount}}</td>
                  <td>{{gst1_desc.B2B_invoices.CESS || 0 | amount}}</td>
                  <td>{{gst1_desc.B2B_invoices.totalInvoice || 0 | amount}}</td>
                  <td>
                    <v-icon @click="openGSTInvoice('B2B_invoices')" color="primary">remove_red_eye</v-icon>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>
                     <h2>{{gst1_desc.B2C_invoices_big.title}}</h2>
                     {{gst1_desc.B2C_invoices_big.description}}
                  </td>
                  <td>{{gst1_desc.B2C_invoices_big.voucherCount}}</td>
                  <td>{{gst1_desc.B2C_invoices_big.totalBaseAmount || 0 | amount}}</td>
                  <td>{{gst1_desc.B2C_invoices_big.ICGST || 0 | amount}}</td>
                  <td>{{gst1_desc.B2C_invoices_big.CGST || 0 | amount}}</td>
                  <td>{{gst1_desc.B2C_invoices_big.SGST || 0 | amount}}</td>
                  <td>{{gst1_desc.B2C_invoices_big.CESS || 0 | amount}}</td>
                  <td>{{gst1_desc.B2C_invoices_big.totalInvoice || 0 | amount}}</td>
                  <td>
                    <v-icon 
                    @click="openGSTInvoice('B2C_invoices_big')" 
                    color="primary">remove_red_eye
                    </v-icon>
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>
                     <h2>{{gst1_desc.Export_invoices.title}}</h2>
                     {{gst1_desc.Export_invoices.description}}
                  </td>
                  <td>{{gst1_desc.Export_invoices.voucherCount}}</td>
                  <td>{{gst1_desc.Export_invoices.totalBaseAmount || 0 | amount}}</td>
                  <td>{{gst1_desc.Export_invoices.ICGST || 0 | amount}}</td>
                  <td>{{gst1_desc.Export_invoices.CGST || 0 | amount}}</td>
                  <td>{{gst1_desc.Export_invoices.SGST || 0 | amount}}</td>
                  <td>{{gst1_desc.Export_invoices.CESS || 0 | amount}}</td>
                  <td>{{gst1_desc.Export_invoices.totalInvoice || 0 | amount}}</td>
                  <td>
                    <v-icon 
                    @click="openGSTInvoice('Export_invoices')" 
                    color="primary">remove_red_eye
                    </v-icon>
                  </td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>
                    <h2>{{gst1_desc.B2C_invoices_small.title}}</h2>
                    {{gst1_desc.B2C_invoices_small.description}}
                  </td>
                  <td>{{gst1_desc.B2C_invoices_small.voucherCount}}</td>
                  <td>{{gst1_desc.B2C_invoices_small.totalBaseAmount || 0 | amount}}</td>
                  <td>{{gst1_desc.B2C_invoices_small.ICGST || 0 | amount}}</td>
                  <td>{{gst1_desc.B2C_invoices_small.CGST || 0 | amount}}</td>
                  <td>{{gst1_desc.B2C_invoices_small.SGST || 0 | amount}}</td>
                  <td>{{gst1_desc.B2C_invoices_small.CESS || 0 | amount}}</td>
                  <td>{{gst1_desc.B2C_invoices_small.totalInvoice || 0 | amount}}</td>
                  <td>
                    <v-icon 
                      @click="openGSTInvoice('B2C_invoices_small')" 
                      color="primary">remove_red_eye</v-icon>
                  </td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>
                    <h2>{{gst1_desc.Nillrated_invoices.title}}</h2>
                    {{gst1_desc.Nillrated_invoices.description}}
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>
                    <h2>{{gst1_desc.Credit_Debit_note_reg.title}}</h2>
                    {{gst1_desc.Credit_Debit_note_reg.description}}
                  </td>
                  <td>{{gst1_desc.Credit_Debit_note_reg.voucherCount}}</td>
                  <td>{{gst1_desc.Credit_Debit_note_reg.totalBaseAmount || 0 | amount}}</td>
                  <td>{{gst1_desc.Credit_Debit_note_reg.ICGST || 0 | amount}}</td>
                  <td>{{gst1_desc.Credit_Debit_note_reg.CGST || 0 | amount}}</td>
                  <td>{{gst1_desc.Credit_Debit_note_reg.SGST || 0 | amount}}</td>
                  <td>{{gst1_desc.Credit_Debit_note_reg.CESS || 0 | amount}}</td>
                  <td>{{gst1_desc.Credit_Debit_note_reg.totalInvoice || 0 | amount}}</td>
                  <td>
                    <v-icon @click="openGSTInvoice('Credit_Debit_note_reg')" color="primary">remove_red_eye</v-icon>
                  </td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>
                    <h2>{{gst1_desc.Credit_Debit_note_unreg.title}}</h2>
                    {{gst1_desc.Credit_Debit_note_unreg.description}}
                  </td>
                  <td>{{gst1_desc.Credit_Debit_note_unreg.voucherCount}}</td>
                  <td>{{gst1_desc.Credit_Debit_note_unreg.totalBaseAmount || 0 | amount}}</td>
                  <td>{{gst1_desc.Credit_Debit_note_unreg.ICGST || 0 | amount}}</td>
                  <td>{{gst1_desc.Credit_Debit_note_unreg.CGST || 0 | amount}}</td>
                  <td>{{gst1_desc.Credit_Debit_note_unreg.SGST || 0 | amount}}</td>
                  <td>{{gst1_desc.Credit_Debit_note_unreg.CESS || 0 | amount}}</td>
                  <td>{{gst1_desc.Credit_Debit_note_unreg.totalInvoice || 0 | amount}}</td>
                  <td>
                    <v-icon @click="openGSTInvoice('Credit_Debit_note_unreg')" color="primary">remove_red_eye</v-icon>
                  </td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>
                    <h2>{{gst1_desc.Tax_Liability.title}}</h2>
                    {{gst1_desc.Tax_Liability.description}}
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>
                    <h2>{{gst1_desc.Adjustment_advance.title}}</h2>
                    {{gst1_desc.Adjustment_advance.description}}
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>
                    <h2>{{gst1_desc.HSN_SAC_Summary.title}}</h2>
                    {{gst1_desc.HSN_SAC_Summary.description}}
                  </td>
                   <td>{{gst1_desc.HSN_SAC_Summary.voucherCount}}</td>
                  <td>{{gst1_desc.HSN_SAC_Summary.totalBaseAmount || 0 | amount}}</td>
                  <td>{{gst1_desc.HSN_SAC_Summary.ICGST || 0 | amount}}</td>
                  <td>{{gst1_desc.HSN_SAC_Summary.CGST || 0 | amount}}</td>
                  <td>{{gst1_desc.HSN_SAC_Summary.SGST || 0 | amount}}</td>
                  <td>{{gst1_desc.HSN_SAC_Summary.CESS || 0 | amount}}</td>
                  <td>{{gst1_desc.HSN_SAC_Summary.totalInvoice || 0 | amount}}</td>
                  <td>
                    <v-icon @click="openGSTInvoice('HSN_SAC_Summary')" color="primary">remove_red_eye</v-icon>
                  </td>
                </tr>
                <tr>
                  <td>11</td>
                  <td>
                    <h2>{{gst1_desc.Document_Summary.title}}</h2>
                    {{gst1_desc.Document_Summary.description}}
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td>
                    <h2>Total</h2>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="dialogGSTReports"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <template>
          <v-toolbar dark color="primary">
            <v-toolbar-title></v-toolbar-title>
             <v-flex xs12>
              <h2 style="text-align: center;">GSTR-1</h2>
              <h3 style="text-align: center;">{{selectedGSTCat.title}} - {{selectedGSTCat.description}}</h3>
            </v-flex>
            <v-btn icon dark @click="dialogGSTReports = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm4 md4 v-if="selectedFirm">
                  Firm name :
                  <b>{{selectedFirm.name}}</b>
                  <br />Address :
                  <b>{{generateAddress(selectedFirm)}}</b>
                  <br />
                  GSTIN :
                  <b>{{selectedFirm.GST_number}}</b>
                  <br />Mobile :
                  <b>{{selectedFirm.mobileNumber}}</b>
                  <br />Email :
                  <b>{{selectedFirm.email}}</b>
                </v-flex>
                 <v-flex xs12 sm8 md8 v-if="selectedGSTCat" style="overflow-x: auto;">
                  <table class="fl-table">
                    <thead>
                      <tr>
                        <th>Description of Invoices</th>
                        <th>Voucher Count</th>
                        <th>Total Taxable Value</th>
                        <th colspan="4">TAX/GST Amounts</th>
                        <th>Total Invoices</th>
                      </tr>
                      <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th>IGST A.</th>
                        <th>CGST A.</th>
                        <th>SGST A.</th>
                        <th>CESS</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <h2>{{selectedGSTCat.title}}</h2>
                          {{selectedGSTCat.description}}
                        </td>
                        <td>{{selectedGSTCat.voucherCount}}</td>
                        <td>{{selectedGSTCat.totalBaseAmount || 0 | amount}}</td>
                        <td>{{selectedGSTCat.ICGST || 0 | amount}}</td>
                        <td>{{selectedGSTCat.CGST || 0 | amount}}</td>
                        <td>{{selectedGSTCat.SGST || 0 | amount}}</td>
                        <td>{{selectedGSTCat.CESS || 0 | amount}}</td>
                        <td>{{selectedGSTCat.totalInvoice || 0 | amount}}</td>
                      </tr>
                    </tbody>
                  </table> 
                </v-flex>
              </v-layout>
              <v-flex xs12>
                <v-btn flat @click="printGST1Individual()">Print</v-btn>
                <v-btn flat type="button" @click="onexport()">Excel</v-btn>
              </v-flex>
            </v-card-text>
          </v-card>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 style="overflow-x: auto;">
                <table class="fl-table" v-if="selectedGSTCat && selectedGSTCat.invoices.length">
                  <template v-if="selectedGSTCat.title == 'HSN/SAC Summary'">
                  <thead>
                    <tr>
                      <th>S. No</th>
                      <th>
                        HSN
                      </th>
                       <th>
                        Description
                      </th>
                      <th>UQC</th>
                      <th>Total Quantity</th>
                      <th>Total Value</th>
                      <th>Total Taxable Value</th>
                      <th colspan="4">TAX Amounts</th>
                    </tr>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th>IGST A.</th>
                      <th>CGST A.</th>
                      <th>SGST A.</th>
                      <th>CESS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(invoice, index) in selectedGSTCat.invoices"
                      :key="`invoice1-${index}`"
                    >
                      <td>{{index+1}}</td>
                      <td>
                        <h2>{{invoice.HSN_code}}</h2>
                      </td>
                      <td>{{invoice.description}}</td>
                      <td>{{invoice.UQC}}</td>
                      <td>{{invoice.quantity}}</td>
                      <td>{{invoice.totalAmount}}</td>
                      <td>{{invoice.basicAmount}}</td>
                      <td>{{invoice.IGST}}</td>
                      <td>{{invoice.CGST}}</td>
                      <td>{{invoice.SGST}}</td>
                      <td>{{invoice.CESS}}</td>
                    </tr>
                  </tbody>
                  </template>
                  <template v-else>
                     <thead>
                    <tr>
                      <th>S. No</th>
                      <th>
                        Customer Name
                        <br />GSTIN/UIN
                        <br />Location
                      </th>
                      <th>Invoice Number</th>
                      <th>Date</th>
                      <th>Taxable Value</th>
                      <th colspan="4">TAX Amounts</th>
                      <th>Invoice Amount</th>
                      <th>Action</th>
                    </tr>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th>IGST A.</th>
                      <th>CGST A.</th>
                      <th>SGST A.</th>
                      <th>CESS</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(invoice, index) in selectedGSTCat.invoices"
                      :key="`invoice-${index}`"
                    >
                      <td>{{index+1}}</td>
                      <td>
                        <h2>{{invoice.buyer.name}}</h2>
                        {{invoice.buyer.GST_number}}
                        <br />
                        {{invoice.buyer.state}}
                      </td>
                      <td>{{invoice.invoiceId}}</td>
                      <td>{{new Date(invoice.date).toLocaleDateString('en-GB')}}</td>
                      <td>{{invoice.basicAmount}}</td>
                      <td>{{invoice.IGST_val}}</td>
                      <td>{{invoice.CGST_val}}</td>
                      <td>{{invoice.SGST_val}}</td>
                      <td>{{invoice.CESS}}</td>
                      <td>{{invoice.totalAmount}}</td>
                      <td></td>
                    </tr>
                  </tbody>
                  </template>
                </table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </template>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import { convertToPDFGST_1_individual, convertToPDFGST_1 } from "../../utils/pdfmake";
import { convertToExcelGST_1All } from "../../utils/excelExport";

import XLSX from 'xlsx'

export default {
  data() {
    return {
      filterType : 'Custom',
      months: [{
            text: 'January',
            value: 0
          },{
            text: 'February',
            value: 1
          },{
            text: 'March',
            value: 2
          },{
            text: 'April',
            value: 3
          },{
            text: 'May',
            value: 4
          },{
            text: 'June',
            value: 5
          },{
            text: 'July',
            value: 6
          },{
            text: 'August',
            value: 7
          },{
            text: 'September',
            value: 8
          },{
            text: 'October',
            value: 9
          },{
            text: 'November',
            value: 10
          },{
            text: 'December',
            value: 11
          }],
      selectedMonth : null,
      selectedQuarter : null,
      quarters : [
        {
          text:'1 April - May - 30 June',
          value : 1
        },
        {
          text:'1 July - Aug - 30 Sept',
          value : 2
        },
        {
          text:'1 Oct  - Nov - 31 Dec',
          value : 3
        },
        {
          text:'1 Jan  -  March - 31 March',
          value : 4
        }
      ],
      selectedFirm: null,
      toDate: null,
      fromDate: null,
      datepickerFrom: null,
      datepickerTo: null,
      invoiceOfFirm: [],
      invoiceOfFirmGST3: [],
      dialogGSTReports: false,
      outwardSupplies: {},
      gst1_desc: {
        B2B_invoices: {
          voucherCount: 0,
          title: "B2B Invoices",
          description: "4A, 4B, 4C, 6B, 6C",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        B2C_invoices_big: {
          voucherCount: 0,
          title: "B2C Invoices [Big]",
          description: "5A, 5B",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        Export_invoices: {
          voucherCount: 0,
          title: "Export Invoices",
          description: "6A",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        B2C_invoices_small: {
          voucherCount: 0,
          title: "B2C Invoices [small]",
          description: "7",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        Nillrated_invoices: {
          voucherCount: 0,
          title: "Nill Rated Invoices",
          description: "8A, 8B, 8C, 8D",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        Credit_Debit_note_reg: {
          voucherCount: 0,
          title: "Credit Note/Debit Note",
          description: "Registered - 9B",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        Credit_Debit_note_unreg: {
          voucherCount: 0,
          title: "Credit Note/Debit Note",
          description: "Unregistered - 9B",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        Tax_Liability: {
          voucherCount: 0,
          title: "TAX Liability(Advanced Received)",
          description: "11(A)1-11(A)2",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        Adjustment_advance: {
          voucherCount: 0,
          title: "Adjustment of Advances",
          description: "11(B)1-11(B)2",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        HSN_SAC_Summary: {
          voucherCount: 0,
          title: "HSN/SAC Summary",
          description: "12",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        Document_Summary: {
          voucherCount: 0,
          title: "Document Summary",
          description: "13",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        Total: {
          voucherCount: 0,
          title: "",
          description: "",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        }
      },
      selectedGSTCat: {
        voucherCount: 0,
        title: "",
        description: "",
        totalBaseAmount: 0,
        ICGST: 0,
        CGST: 0,
        SGST: 0,
        CESS: 0,
        totalInvoice: 0,
        invoices: []
      }
    };
  },
  created() {
    if(this.finYear) {
        this.fromDate =  new Date(this.finYear.start).toISOString().substr(0, 10);
        this.toDate = new Date(this.finYear.end).toISOString().substr(0, 10);
    }
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("buyer", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("seller", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    //this.resetGST3("outwardSupplies");
    //this.getInvoiceGST3();
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","finYear","brandFinYear"]),
    firmsByBrand1 () {
      return this.firms.filter(item => item["brand"] === this.selectedBrand);
    },
    // current brands firm list
    firmsByBrand () {
        // return selected brand firms
        let firmsB = this.firms
          .filter((item) => item['brand'] === this.selectedBrand)
          firmsB.map((item) => {
            if (item.defaultFirm) {
              this.selectedFirm = item;
            }
          })
        return firmsB;
    },
  },
  methods: {
    // Start to Export in XLSX
    downloadJSON(){
      var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.gst1_desc));
      var dlAnchorElem = document.getElementById('downloadAnchorElem');
      dlAnchorElem.setAttribute("href",     dataStr     );
      dlAnchorElem.setAttribute("download", "GST1.json");
      dlAnchorElem.click();
    },
    toggle(item) {
      item.expand = !item.expand;
    },
    printGST1() {
      let firm = this.selectedFirm;
      firm.address = this.generateAddress(firm);
      let doc = convertToPDFGST_1({
        firm: firm,
        outwardSupplies: this.outwardSupplies,
        gst1: this.gst1_desc
      });
      pdfMake.createPdf(doc).download();
    },
    exportAll() {
      let firm = this.selectedFirm;
      firm.address = this.generateAddress(firm);
      let wb = convertToExcelGST_1All({
        selectedFirm: firm,
        B2B_invoices: this.gst1_desc.B2B_invoices,
        B2C_invoices_big: this.gst1_desc.B2C_invoices_big,
        B2C_invoices_small: this.gst1_desc.B2C_invoices_small,
        Nillrated_invoices: this.gst1_desc.Nillrated_invoices,
        Export_invoices: this.gst1_desc.Export_invoices,
        Adjustment_advance: this.gst1_desc.Adjustment_advance,
        Tax_Liability: this.gst1_desc.Tax_Liability,
        Credit_Debit_note_reg: this.gst1_desc.Credit_Debit_note_reg,
        Credit_Debit_note_unreg: this.gst1_desc.Credit_Debit_note_unreg,
        HSN_SAC_Summary: this.gst1_desc.HSN_SAC_Summary,
        Document_Summary: this.gst1_desc.Document_Summary
      });
      XLSX.writeFile(wb, "GST1_" + new Date().getTime() + ".xlsx"); // name of the file is 'book.xlsx'
    },
    onexport() {
      // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      let invoicesHeader = {
        s_no: "S. No",
        location: "Location",
        name: "Customer Name",
        gstin: "GSTIN/UIN",
        invoiceId: "Invoice Number",
        date: "Date",
        basicAmount: "Taxable Value",
        IGST_val: "IGST Amount",
        CGST_val: "CGST Amount",
        SGST_val: "SGST Amount",
        CESS: "CESS Amount",
        totalAmount: "Total Invoices"
      };

      let firmHeader = {
        name: "Name",
        address: "Address",
        mobileNumber: "Mobile",
        panNumber: "PAN Number",
        email: "Email",
        GST_number: "GST Number",
        website: "Website"
      };

      let selectedInvoiceTypeHeader = {
        title: "Description of Invoices",
        voucherCount: "Voucher Count",
        totalBaseAmount: "Total Taxable Value",
        ICGST: "IGST Amount",
        CGST: "CGST Amount",
        SGST: "SGST Amount",
        CESS: "CESS",
        totalInvoice: "Total Invoices"
      };

      let invoiceData = [
        invoicesHeader,
        ...this.selectedGSTCat.invoices.map((invoice, index) => {
          return {
            s_no: index + 1,
            location: invoice.buyer.state,
            name: invoice.buyer.name,
            gstin: invoice.buyer.GST_number,
            invoiceId: invoice.invoiceId,
            date: new Date(invoice.date).toLocaleDateString("en-GB"),
            basicAmount: invoice.basicAmount,
            IGST_val: invoice.IGST_val,
            CGST_val: invoice.CGST_val,
            SGST_val: invoice.SGST_val,
            CESS: invoice.CESS,
            totalAmount: invoice.totalAmount
          };
        })
      ];

      let firmData = [
        firmHeader,
        {
          name: this.selectedFirm.name,
          address: this.generateAddress(this.selectedFirm),
          mobileNumber: this.selectedFirm.mobileNumber,
          panNumber: this.selectedFirm.panNumber,
          email: this.selectedFirm.email,
          GST_number: this.selectedFirm.GST_number,
          website: this.selectedFirm.website
        }
      ];

      let selectedInvoiceTypeData = [
        selectedInvoiceTypeHeader,
        {
          title: this.selectedGSTCat.title,
          voucherCount: this.selectedGSTCat.voucherCount,
          totalBaseAmount: this.selectedGSTCat.totalBaseAmount,
          ICGST: this.selectedGSTCat.ICGST,
          CGST: this.selectedGSTCat.CGST,
          SGST: this.selectedGSTCat.SGST,
          CESS: this.selectedGSTCat.CESS,
          totalInvoice: this.selectedGSTCat.totalInvoice
        }
      ];

      var invoiceWS = XLSX.utils.json_to_sheet(invoiceData, {
        skipHeader: true
      });
      var firmWS = XLSX.utils.json_to_sheet(firmData, { skipHeader: true });
      var selectedInvoiceTypeWS = XLSX.utils.json_to_sheet(
        selectedInvoiceTypeData,
        { skipHeader: true }
      );

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, invoiceWS, "Invoices");
      XLSX.utils.book_append_sheet(
        wb,
        selectedInvoiceTypeWS,
        this.selectedGSTCat.title
      ); // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, firmWS, "Firm");

      // export Excel file
      XLSX.writeFile(wb, "GST1_" + new Date().getTime() + ".xlsx"); // name of the file is 'book.xlsx'
    },
    // End of export of Excel

    // Start of Print and Save in PDF
    printGST1Individual() {
      let doc = convertToPDFGST_1_individual({
        firm: this.selectedFirm,
        selectedGSTCat: this.selectedGSTCat
      });
      console.log(JSON.stringify(doc, null, 4));
      pdfMake.createPdf(doc).download();
    },
    openGSTInvoice(GSTCategory) {
      this.selectedGSTCat = this.gst1_desc[GSTCategory];
      this.selectedGSTCat.invoices.sort(function(a, b) {
        return -(new Date(b.date) - new Date(a.date));
      });
      this.dialogGSTReports = true;
    },
    calculateGSTInvoice(currentUser, invoice) {
      let SGST_val = 0;
      let CGST_val = 0;
      let IGST_val = 0;
      invoice.items &&
        invoice.items.map((item, index) => {
          if(invoice.gstType == 'SGST|CGST') {
              SGST_val += parseFloat(item["SGST_val"]);
              CGST_val += parseFloat(item["CGST_val"]);
          } else {
              IGST_val += parseFloat(item["IGST_val"]);
          }
        });
      return { SGST_val, CGST_val, IGST_val };
    },
    reset(obj) {
      let title = this.gst1_desc[obj].title;
      let description = this.gst1_desc[obj].description;
      this.gst1_desc[obj] = {
        voucherCount: 0,
        totalBaseAmount: 0,
        ICGST: 0,
        CGST: 0,
        SGST: 0,
        CESS: 0,
        totalInvoice: 0,
        invoices: [],
        title: title,
        description: description
      };
    },
    resetGST3(obj) {
      this[obj] = {
        totalBaseAmount: 0,
        IGST: 0,
        CGST: 0,
        SGST: 0,
        CESS: 0,
        totalInvoiceAmount: 0,
        expand: false,
        intraState: {
          totalBaseAmount: 0,
          IGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoiceAmount: 0,
          taxable: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0,
            expand: false,
            GST_3: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_5: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_12: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_18: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_28: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            }
          },

          exempted: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          },
          nillrated: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          },
          others: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          }
        },
        interState: {
          totalBaseAmount: 0,
          IGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoiceAmount: 0,
          taxable: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0,
             expand: false,
            GST_3: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_5: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_12: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_18: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_28: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            }
          },
          exempted: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          },
          nillrated: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          },
          others: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          }
        }
      };
    },
    getGSTtotal(item) {
      let GSTTotal = 0;
      item &&
        item.items &&
        item.items.map(item => {
          GSTTotal += Number.parseFloat(item.GSTValue);
        });
      return GSTTotal;
    },
    getInvoiceGST3() {
      let toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      this.invoiceOfFirmGST3 = this.invoices.filter(item => {
        return (
          item["brand"] === this.selectedBrand &&
          (this.selectedFirm
            ? this.selectedFirm[".key"] === item["firm"]
            : true) && 
            (!item.return) &&
          (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true)
        );
      });
      this.resetGST3("outwardSupplies");
      this.invoiceOfFirmGST3.map(invoice => {
          let gst = this.getGSTtotal(invoice);
          let buyer = null;
          if (invoice.isBuyer) {
            buyer = this.buyer[invoice.buyerId];
          } else {
            buyer = this.seller[invoice.buyerId];
          }
          let gstType = this.calculateGSTInvoice(buyer, invoice);
          if (invoice.isBuyer) {
            // this.outwardSupplies.totalBaseAmount +=
            //   parseFloat(invoice.totalAmount) - gst;
            // this.outwardSupplies.totalInvoiceAmount += parseFloat(
            //   invoice.totalAmount
            // );
            if (invoice.gstType == 'SGST|CGST') {
              this.calculateFromProduct(
                "outwardSupplies",
                "intraState",
                invoice,
                true
              );
              // this.outwardSupplies.CGST += parseFloat(gstType["CGST_val"]);
              // this.outwardSupplies.SGST += parseFloat(gstType["SGST_val"]);
            } else {
              this.calculateFromProduct(
                "outwardSupplies",
                "interState",
                invoice,
                false
              );
              // this.outwardSupplies.IGST += parseFloat(gstType["IGST_val"]);
            }
          }
      });
    },
    calculateFromProduct(type, subType, invoice, sameState) {
      invoice.items &&
        invoice.items.map(product => {
          switch (product.GST_type) {
            case "EXEMPT": {
              this[type][subType]["exempted"].totalBaseAmount += parseFloat(
                product.basicPrice
              );
              this[type][subType]["exempted"].totalInvoiceAmount += parseFloat(
                product.totlePrice
              );
              if (sameState) {
                this[type][subType]["exempted"].CGST += parseFloat(
                  product.CGST_val
                );
                this[type][subType]["exempted"].SGST += parseFloat(
                  product.SGST_val
                );
              } else {
                this[type][subType]["exempted"].IGST += parseFloat(
                  product.IGST_val
                );
              }
              break;
            }
            case "NILL": {
              this[type][subType]["nillrated"].totalBaseAmount += parseFloat(
                product.basicPrice
              );
              this[type][subType]["nillrated"].totalInvoiceAmount += parseFloat(
                product.totlePrice
              );
              if (sameState) {
                this[type][subType]["nillrated"].CGST += parseFloat(
                  product.CGST_val
                );
                this[type][subType]["nillrated"].SGST += parseFloat(
                  product.SGST_val
                );
              } else {
                this[type][subType]["nillrated"].IGST += parseFloat(
                  product.IGST_val
                );
              }
              break;
            }
            case "TAXABLE": {
              this[type][subType]["taxable"].totalBaseAmount += parseFloat(
                product.basicPrice
              );
              this[type][subType]["taxable"].totalInvoiceAmount += parseFloat(
                product.totlePrice
              );
              if (sameState) {
                this[type][subType]["taxable"].CGST += parseFloat(
                  product.CGST_val
                );
                this[type][subType]["taxable"].SGST += parseFloat(
                  product.SGST_val
                );
              } else {
                this[type][subType]["taxable"].IGST += parseFloat(
                  product.IGST_val
                );
              }
              switch (product.taxableGST_rate) {
                case 3: {
                  this[type][subType]["taxable"][
                    "GST_3"
                  ].totalBaseAmount += parseFloat(product.basicPrice);
                  this[type][subType]["taxable"][
                    "GST_3"
                  ].totalInvoiceAmount += parseFloat(product.totlePrice);
                  if (sameState) {
                    this[type][subType]["taxable"]["GST_3"].CGST += parseFloat(
                      product.CGST_val
                    );
                    this[type][subType]["taxable"]["GST_3"].SGST += parseFloat(
                      product.SGST_val
                    );
                  } else {
                    this[type][subType]["taxable"]["GST_3"].IGST += parseFloat(
                      product.IGST_val
                    );
                  }
                  break;
                }
                case 5: {
                  this[type][subType]["taxable"][
                    "GST_5"
                  ].totalBaseAmount += parseFloat(product.basicPrice);
                  this[type][subType]["taxable"][
                    "GST_5"
                  ].totalInvoiceAmount += parseFloat(product.totlePrice);
                  if (sameState) {
                    this[type][subType]["taxable"]["GST_5"].CGST += parseFloat(
                      product.CGST_val
                    );
                    this[type][subType]["taxable"]["GST_5"].SGST += parseFloat(
                      product.SGST_val
                    );
                  } else {
                    this[type][subType]["taxable"]["GST_5"].IGST += parseFloat(
                      product.IGST_val
                    );
                  }
                  break;
                }
                case 12: {
                  this[type][subType]["taxable"][
                    "GST_12"
                  ].totalBaseAmount += parseFloat(product.basicPrice);
                  this[type][subType]["taxable"][
                    "GST_12"
                  ].totalInvoiceAmount += parseFloat(product.totlePrice);
                  if (sameState) {
                    this[type][subType]["taxable"]["GST_12"].CGST += parseFloat(
                      product.CGST_val
                    );
                    this[type][subType]["taxable"]["GST_12"].SGST += parseFloat(
                      product.SGST_val
                    );
                  } else {
                    this[type][subType]["taxable"]["GST_12"].IGST += parseFloat(
                      product.IGST_val
                    );
                  }
                  break;
                }
                case 18: {
                
                  this[type][subType]["taxable"][
                    "GST_18"
                  ].totalBaseAmount += parseFloat(product.basicPrice);
                  this[type][subType]["taxable"][
                    "GST_18"
                  ].totalInvoiceAmount += parseFloat(product.totlePrice);
                  if (sameState) {
                    this[type][subType]["taxable"]["GST_18"].CGST += parseFloat(
                      product.CGST_val
                    );
                    this[type][subType]["taxable"]["GST_18"].SGST += parseFloat(
                      product.SGST_val
                    );
                  } else {
                    this[type][subType]["taxable"]["GST_18"].IGST += parseFloat(
                      product.IGST_val
                    );
                  }
                  break;
                }
                case 28: {
                  this[type][subType]["taxable"][
                    "GST_28"
                  ].totalBaseAmount += parseFloat(product.basicPrice);
                  this[type][subType]["taxable"][
                    "GST_28"
                  ].totalInvoiceAmount += parseFloat(product.totlePrice);
                  if (sameState) {
                    this[type][subType]["taxable"]["GST_28"].CGST += parseFloat(
                      product.CGST_val
                    );
                    this[type][subType]["taxable"]["GST_28"].SGST += parseFloat(
                      product.SGST_val
                    );
                  } else {
                    this[type][subType]["taxable"]["GST_28"].IGST += parseFloat(
                      product.IGST_val
                    );
                  }
                  break;
                }
              }
              break;
            }
            case "OTHER": {
              this[type][subType]["others"].totalBaseAmount += parseFloat(
                product.basicPrice
              );
              this[type][subType]["others"].totalInvoiceAmount += parseFloat(
                product.totlePrice
              );
              if (sameState) {
                this[type][subType]["others"].CGST += parseFloat(
                  product.CGST_val
                );
                this[type][subType]["others"].SGST += parseFloat(
                  product.SGST_val
                );
              } else {
                this[type][subType]["others"].IGST += parseFloat(
                  product.IGST_val
                );
              }
              break;
            }
          }
          
          this[type][subType].totalBaseAmount += parseFloat(product.basicPrice);
          this[type][subType].totalInvoiceAmount += parseFloat(
            product.totlePrice
          );

          this[type].totalBaseAmount += parseFloat(product.basicPrice);
          this[type].totalInvoiceAmount += parseFloat(
            product.totlePrice
          );
          if (sameState) {
            this[type][subType].CGST += parseFloat(product.CGST_val);
            this[type][subType].SGST += parseFloat(product.SGST_val);
            this[type].CGST += parseFloat(product.CGST_val);
            this[type].SGST += parseFloat(product.SGST_val);
          } else {
            this[type][subType].IGST += parseFloat(product.IGST_val);
             this[type].IGST += parseFloat(product.IGST_val);
          }
        });
    },
    getInvoice() {
      let toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      let selectedBuyers = this.buyers.filter(
        item => item["brand"] === this.selectedBrand
      );
      this.invoiceOfFirm = this.invoices.filter(item => {
        return (
          item["brand"] === this.selectedBrand &&
          item["firm"] === this.selectedFirm[".key"] &&
          (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true)
        );
      });
      this.reset("B2B_invoices");
      this.reset("B2C_invoices_big");
      this.reset("Export_invoices");
      this.reset("B2C_invoices_small");
      this.reset("Credit_Debit_note_reg");
      this.reset("Credit_Debit_note_unreg");
      selectedBuyers.map(buyer => {
        if (buyer.GST_user === "Yes") {
          let B2BInvoices = this.invoiceOfFirm.filter(item => {
            return (item["buyerId"] === buyer[".key"])
          });
          B2BInvoices.map(invoice => {
            let gst = this.getGSTtotal(invoice);
            let gstType = this.calculateGSTInvoice(buyer, invoice);
            this.gst1_desc.B2B_invoices.voucherCount += 1;
            this.gst1_desc.B2B_invoices.totalBaseAmount +=
              parseFloat(invoice.totalAmount) - gst;
            this.gst1_desc.B2B_invoices.totalInvoice += parseFloat(
              invoice.totalAmount
            );
            (this.gst1_desc.B2B_invoices.ICGST += parseFloat(
              gstType["IGST_val"]
            )),
              (this.gst1_desc.B2B_invoices.CGST += parseFloat(
                gstType["CGST_val"]
              )),
              (this.gst1_desc.B2B_invoices.SGST += parseFloat(
                gstType["SGST_val"]
              ));
            invoice["buyer"] = buyer;
            invoice["IGST_val"] = gstType["IGST_val"];
            invoice["CGST_val"] = gstType["CGST_val"];
            invoice["SGST_val"] = gstType["SGST_val"];
            invoice["basicAmount"] = parseFloat(invoice.totalAmount) - gst;
            this.gst1_desc.B2B_invoices.invoices.push(invoice);
            if(buyer.country != 'India') {
              this.gst1_desc.Export_invoices.voucherCount = 1;
              this.gst1_desc.Export_invoices.totalBaseAmount =
              parseFloat(invoice.totalAmount) - gst;
            this.gst1_desc.Export_invoices.totalInvoice = parseFloat(
              invoice.totalAmount
            );
            (this.gst1_desc.Export_invoices.ICGST = parseFloat(
              gstType["IGST_val"]
            )),
              (this.gst1_desc.Export_invoices.CGST = parseFloat(
                gstType["CGST_val"]
              )),
              (this.gst1_desc.Export_invoices.SGST = parseFloat(
                gstType["SGST_val"]
              ));
              this.gst1_desc.Export_invoices.invoices.push(invoice);
            }
            if (invoice["return"] === true) {
              this.gst1_desc.Credit_Debit_note_reg.voucherCount += 1;
              this.gst1_desc.Credit_Debit_note_reg.totalBaseAmount +=
                parseFloat(invoice.totalAmount) - gst;
              this.gst1_desc.Credit_Debit_note_reg.totalInvoice += parseFloat(
                invoice.totalAmount
              );
              (this.gst1_desc.Credit_Debit_note_reg.ICGST += parseFloat(
                gstType["IGST_val"]
              )),
                (this.gst1_desc.Credit_Debit_note_reg.CGST += parseFloat(
                  gstType["CGST_val"]
                )),
                (this.gst1_desc.Credit_Debit_note_reg.SGST += parseFloat(
                  gstType["SGST_val"]
                ));
              invoice["buyer"] = buyer;
              invoice["IGST_val"] = gstType["IGST_val"];
              invoice["CGST_val"] = gstType["CGST_val"];
              invoice["SGST_val"] = gstType["SGST_val"];
              invoice["basicAmount"] = parseFloat(invoice.totalAmount) - gst;
              this.gst1_desc.Credit_Debit_note_reg.invoices.push(invoice);
            }
          });
        } else {
          let B2CInvoicesBig = this.invoiceOfFirm.filter(item => {
            return (item["buyerId"] === buyer[".key"] && item["totalAmount"] >= 150000);
          });
          B2CInvoicesBig.map(invoice => {
            let gst = this.getGSTtotal(invoice);
            let gstType = this.calculateGSTInvoice(buyer, invoice);
            this.gst1_desc.B2C_invoices_big.voucherCount += 1;
            this.gst1_desc.B2C_invoices_big.totalBaseAmount +=
              parseFloat(invoice.totalAmount) - gst;
            this.gst1_desc.B2C_invoices_big.totalInvoice += parseFloat(
              invoice.totalAmount
            );
            (this.gst1_desc.B2C_invoices_big.ICGST += parseFloat(
              gstType["IGST_val"]
            )),
              (this.gst1_desc.B2C_invoices_big.CGST += parseFloat(
                gstType["CGST_val"]
              )),
              (this.gst1_desc.B2C_invoices_big.SGST += parseFloat(
                gstType["SGST_val"]
              ));
            invoice["buyer"] = buyer;
            invoice["IGST_val"] = gstType["IGST_val"];
            invoice["CGST_val"] = gstType["CGST_val"];
            invoice["SGST_val"] = gstType["SGST_val"];
            invoice["basicAmount"] = parseFloat(invoice.totalAmount) - gst;
            this.gst1_desc.B2C_invoices_big.invoices.push(invoice);

            if (invoice["return"] === true) {
              this.gst1_desc.Credit_Debit_note_unreg.voucherCount += 1;
              this.gst1_desc.Credit_Debit_note_unreg.totalBaseAmount +=
                parseFloat(invoice.totalAmount) - gst;
              this.gst1_desc.Credit_Debit_note_unreg.totalInvoice += parseFloat(
                invoice.totalAmount
              );
              (this.gst1_desc.Credit_Debit_note_unreg.ICGST += parseFloat(
                gstType["IGST_val"]
              )),
                (this.gst1_desc.Credit_Debit_note_unreg.CGST += parseFloat(
                  gstType["CGST_val"]
                )),
                (this.gst1_desc.Credit_Debit_note_unreg.SGST += parseFloat(
                  gstType["SGST_val"]
                ));
              invoice["buyer"] = buyer;
              invoice["IGST_val"] = gstType["IGST_val"];
              invoice["CGST_val"] = gstType["CGST_val"];
              invoice["SGST_val"] = gstType["SGST_val"];
              invoice["basicAmount"] = parseFloat(invoice.totalAmount) - gst;
              this.gst1_desc.Credit_Debit_note_unreg.invoices.push(invoice);
            }
          });
          let B2CInvoicesSmall = this.invoiceOfFirm.filter(item => {
            return item["buyerId"] === buyer[".key"] && item["totalAmount"] < 150000;
          });
          B2CInvoicesSmall.map(invoice => {
            let gst = this.getGSTtotal(invoice);
            let gstType = this.calculateGSTInvoice(buyer, invoice);
            this.gst1_desc.B2C_invoices_small.voucherCount += 1;
            this.gst1_desc.B2C_invoices_small.totalBaseAmount +=
              parseFloat(invoice.totalAmount) - gst;
            this.gst1_desc.B2C_invoices_small.totalInvoice += parseFloat(
              invoice.totalAmount
            );
            (this.gst1_desc.B2C_invoices_small.ICGST += parseFloat(
              gstType["IGST_val"]
            )),
              (this.gst1_desc.B2C_invoices_small.CGST += parseFloat(
                gstType["CGST_val"]
              )),
              (this.gst1_desc.B2C_invoices_small.SGST += parseFloat(
                gstType["SGST_val"]
              ));
            invoice["buyer"] = buyer;
            invoice["IGST_val"] = gstType["IGST_val"];
            invoice["CGST_val"] = gstType["CGST_val"];
            invoice["SGST_val"] = gstType["SGST_val"];
            invoice["basicAmount"] = parseFloat(invoice.totalAmount) - gst;
            this.gst1_desc.B2C_invoices_small.invoices.push(invoice);

            if (invoice["return"] === true) {
              this.gst1_desc.Credit_Debit_note_unreg.voucherCount += 1;
              this.gst1_desc.Credit_Debit_note_unreg.totalBaseAmount +=
                parseFloat(invoice.totalAmount) - gst;
              this.gst1_desc.Credit_Debit_note_unreg.totalInvoice += parseFloat(
                invoice.totalAmount
              );
              (this.gst1_desc.Credit_Debit_note_unreg.ICGST += parseFloat(
                gstType["IGST_val"]
              )),
                (this.gst1_desc.Credit_Debit_note_unreg.CGST += parseFloat(
                  gstType["CGST_val"]
                )),
                (this.gst1_desc.Credit_Debit_note_unreg.SGST += parseFloat(
                  gstType["SGST_val"]
                ));
              invoice["buyer"] = buyer;
              invoice["IGST_val"] = gstType["IGST_val"];
              invoice["CGST_val"] = gstType["CGST_val"];
              invoice["SGST_val"] = gstType["SGST_val"];
              invoice["basicAmount"] = parseFloat(invoice.totalAmount) - gst;
              this.gst1_desc.Credit_Debit_note_unreg.invoices.push(invoice);
            }
          });
          this.reset("HSN_SAC_Summary");
          let HSN_SAC_Summary = {}
          this.invoiceOfFirm.map((invoice)=>{
            invoice.items && invoice.items.map((item)=>{
              if(item.HSN_code && !HSN_SAC_Summary[item.HSN_code]) {
                HSN_SAC_Summary[item.HSN_code] = {
                  HSN_code : item.HSN_code,
                  description : '',
                  UQC : '',
                  quantity : 0,
                  totalAmount : 0,
                  basicAmount : 0,
                  IGST : 0,
                  CGST : 0,
                  SGST : 0,
                  CESS : 0
                };
              } 
              if(item.HSN_code) {
                HSN_SAC_Summary[item.HSN_code].quantity += parseInt(item.quantity)
                HSN_SAC_Summary[item.HSN_code].totalAmount += Number.parseInt(item.totlePrice)
                HSN_SAC_Summary[item.HSN_code].basicAmount += Number.parseInt(item.basicPrice)
                HSN_SAC_Summary[item.HSN_code].IGST += Number.parseInt(item.IGST_val)
                HSN_SAC_Summary[item.HSN_code].CGST += Number.parseInt(item.CGST_val)
                HSN_SAC_Summary[item.HSN_code].SGST += Number.parseInt(item.SGST_val)

                this.gst1_desc.HSN_SAC_Summary.voucherCount +=1;
                this.gst1_desc.HSN_SAC_Summary.totalBaseAmount += Number.parseInt(item.basicPrice);
                this.gst1_desc.HSN_SAC_Summary.ICGST +=Number.parseInt(item.IGST_val);
                this.gst1_desc.HSN_SAC_Summary.CGST +=Number.parseInt(item.CGST_val);
                this.gst1_desc.HSN_SAC_Summary.SGST +=Number.parseInt(item.SGST_val);
                this.gst1_desc.HSN_SAC_Summary.totalInvoice +=Number.parseInt(item.totlePrice);
              }
            })
          })
          Object.keys(HSN_SAC_Summary).forEach((key)=> {
            this.gst1_desc.HSN_SAC_Summary.invoices.push(HSN_SAC_Summary[key]);
          });
        }
      });
      //this.setData();
    },
    // setData() {
    //   let toDate = this.toDate ? new Date(this.toDate).getTime() : null;
    //   let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
    //   this.invoiceOfFirm.map(invoice => {});
    // },
    generateAddress(user) {
      let address = "";
      if (user.block) {
        address = `${user.block}`;
      }
      if (user.village) {
        address = `${address ? address + " - " : ""}${user.village}`;
      }
      if (user.tehsil) {
        address = `${address ? address + " - " : ""}${user.tehsil}`;
      }
      if (user.state) {
        address = `${address ? address + " - " : ""}${user.state}`;
      }
      return address;
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
  },
  watch: {
    selectedFirm(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.getInvoice();
        this.getInvoiceGST3();
        //this.setData();
      }
    },
    toDate(newVal, oldVal) {
      if (oldVal !== newVal && this.selectedFirm) {
        this.getInvoice();
        this.getInvoiceGST3();
        //this.setData();
      }
    },
    fromDate(newVal, oldVal) {
      if (oldVal !== newVal && this.selectedFirm) {
        this.getInvoice();
        this.getInvoiceGST3();
        // this.setData();
      }
    },
    selectedMonth(newVal, oldVal){
      let selectedMonth = newVal;
      let dateFrom = new Date(this.finYear.start);
      let dateTo = new Date(this.finYear.end);
      let fullYear = dateFrom.getFullYear()
      if(selectedMonth < 3) {
        fullYear = dateTo.getFullYear()
      }
      this.fromDate = this.formatDate(new Date(fullYear, selectedMonth, 1).getTime());
      this.toDate = this.formatDate(new Date(fullYear, selectedMonth + 1, 0).getTime());
    },
    selectedQuarter(newVal, oldVal) {
      let selectedQuarter = newVal;
      let selectedMonthFrom = null;
      let selectedMonthTo = null;
      let dateFrom = new Date(this.finYear.start);
      let dateTo = new Date(this.finYear.end);
      let fullYear = dateFrom.getFullYear()
      switch(selectedQuarter) {
        case 1 : {
          selectedMonthFrom = 3;
          selectedMonthTo = 5;
          break;
        }
        case 2 : {
          selectedMonthFrom = 6;
          selectedMonthTo = 8;
          break;
        }
        case 3 : {
          selectedMonthFrom = 9;
          selectedMonthTo = 11;
          break;
        }
        case 4 : {
          selectedMonthFrom = 0;
          selectedMonthTo = 2;
          fullYear = dateTo.getFullYear()
          break;
        }
      }
      this.fromDate = this.formatDate(new Date(fullYear, selectedMonthFrom, 1).getTime());
      this.toDate = this.formatDate(new Date(fullYear, selectedMonthTo+1, 0).getTime());
    }
  }
};
</script>

<style >
.theme--light div.select-firm .v-icon {
  color: white;
}
.theme--light div.select-firm .v-label {
  color: white;
}
.theme--light div.select-firm .v-input__slot:before {
  border-color: white !important;
}
div.select-firm .v-select__selection--comma {
  color: white;
}

.disabledCard {
  background: lightgray;
}

.ist-datepicker .v-icon,
.ist-datepicker .v-label,
.ist-datepicker input {
  color: white !important;
}

.ist-datepicker .v-input__slot:before {
  border-color: white !important;
}

.fl-table {
  border-radius: 5px;
  font-size: 12px;
  font-weight: normal;
  border: none;
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  background-color: white;
}

.fl-table td,
.fl-table th {
  text-align: center;
  padding: 8px;
}

.fl-table td {
  border: 1px solid #000000;
  font-size: 12px;
}

.fl-table thead th {
  color: #ffffff;
  background: #324960;
  border: 1px solid black;
}

.fl-table tr:nth-child(even) {
  background: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/components/GSTReports/gst1.vue